import { AttachmentPlusIcon } from './AttachmentPlusIcon';

/**
 * author: Colton Wiscombe
 * id F0017157-A798-401D-9B19-464C1BB25EA4
 * name attachment-plus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/attachment-plus.svg
 * tags
 */
export const AttachmentAddIcon = AttachmentPlusIcon;
export default AttachmentAddIcon